/* ============================================================
   Ellara Grace — shared theme JavaScript
   Load once in theme.liquid (defer):
   <script src="{{ 'ellara-grace.js' | asset_url }}" defer></script>
   Re-initialises on Shopify theme-editor section load/select.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Mobile drawer ---------- */
  function initDrawer(root) {
    var burger = root.querySelector('[data-eg-burger]');
    var drawer = root.querySelector('[data-eg-drawer]');
    if (!burger || !drawer) return;
    var open = function () { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; };
    var close = function () { drawer.classList.remove('is-open'); document.body.style.overflow = ''; };
    burger.addEventListener('click', open);
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer || e.target.hasAttribute('data-eg-drawer-close')) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- Product gallery (thumbs + swipe + zoom) ---------- */
  function initGallery(section) {
    var main = section.querySelector('[data-eg-gallery-main]');
    var thumbs = section.querySelectorAll('[data-eg-thumb]');
    if (!main || !thumbs.length) return;

    function show(i) {
      var slides = main.querySelectorAll('[data-eg-slide]');
      slides.forEach(function (s, idx) { s.style.display = idx === i ? 'block' : 'none'; });
      thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === i); });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    show(0);

    // hover zoom (desktop)
    var zoomTarget = main.querySelector('[data-eg-zoom]');
    if (zoomTarget && window.matchMedia('(hover:hover)').matches) {
      main.addEventListener('mousemove', function (e) {
        var r = main.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width) * 100;
        var y = ((e.clientY - r.top) / r.height) * 100;
        zoomTarget.style.transformOrigin = x + '% ' + y + '%';
        zoomTarget.style.transform = 'scale(1.8)';
      });
      main.addEventListener('mouseleave', function () { zoomTarget.style.transform = ''; });
    }

    // touch swipe
    var sx = 0, idx = 0;
    main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) < 40) return;
      idx = Math.max(0, Math.min(thumbs.length - 1, idx + (dx < 0 ? 1 : -1)));
      show(idx);
    }, { passive: true });
  }

  /* ---------- Review carousel (scroll-snap + arrows) ---------- */
  function initCarousel(section) {
    var track = section.querySelector('[data-eg-carousel]');
    if (!track) return;
    var prev = section.querySelector('[data-eg-prev]');
    var next = section.querySelector('[data-eg-next]');
    var step = function () { return track.clientWidth * 0.7; };
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  }

  /* ---------- Before / after slider ---------- */
  function initBeforeAfter(section) {
    var range = section.querySelector('[data-eg-ba-range]');
    if (!range) return;
    var before = section.querySelector('[data-eg-ba-before]');
    var handle = section.querySelector('[data-eg-ba-handle]');
    var apply = function () {
      var v = range.value;
      if (before) before.style.width = v + '%';
      if (handle) handle.style.left = v + '%';
    };
    range.addEventListener('input', apply);
    apply();
  }

  /* ---------- FAQ accordion ---------- */
  function initFaq(section) {
    var items = section.querySelectorAll('[data-eg-faq-item]');
    items.forEach(function (item) {
      var btn = item.querySelector('[data-eg-faq-q]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        items.forEach(function (s) { s.classList.remove('is-open'); });
        if (!isOpen) item.classList.add('is-open');
      });
    });
  }

  /* ---------- Routine builder ---------- */
  function initRoutine(section) {
    var concerns = section.querySelectorAll('[data-eg-rb-concern]');
    if (!concerns.length) return;
    var prodCol = section.querySelector('[data-eg-rb-products-col]');
    var resultCol = section.querySelector('[data-eg-rb-result-col]');
    var resultText = section.querySelector('[data-eg-rb-result-text]');
    var products = section.querySelectorAll('[data-eg-rb-product]');
    var state = { concern: null, product: null };

    function paintResult() {
      if (!resultText) return;
      if (state.product) {
        resultText.textContent = "We'd start your " + (state.concern || '').toLowerCase() +
          ' ritual with the ' + state.product + '.';
      } else {
        resultText.textContent = 'Your personalised ritual will appear here once you choose.';
      }
    }
    concerns.forEach(function (c) {
      c.addEventListener('click', function () {
        state.concern = c.getAttribute('data-eg-rb-concern');
        state.product = null;
        concerns.forEach(function (x) { x.classList.remove('is-active'); });
        c.classList.add('is-active');
        products.forEach(function (x) { x.classList.remove('is-active'); });
        if (prodCol) prodCol.setAttribute('data-locked', 'false');
        paintResult();
      });
    });
    products.forEach(function (p) {
      p.addEventListener('click', function () {
        if (!state.concern) return;
        state.product = p.getAttribute('data-eg-rb-product');
        products.forEach(function (x) { x.classList.remove('is-active'); });
        p.classList.add('is-active');
        if (resultCol) resultCol.setAttribute('data-locked', 'false');
        paintResult();
      });
    });
  }

  /* ---------- Variant select + qty + sticky bar sync ---------- */
  function initBuybox(section) {
    var variants = section.querySelectorAll('[data-eg-variant]');
    var idInput = section.querySelector('[data-eg-variant-id]');
    var qtyInput = section.querySelector('[data-eg-qty-input]');
    var minus = section.querySelector('[data-eg-qty-minus]');
    var plus = section.querySelector('[data-eg-qty-plus]');

    variants.forEach(function (v) {
      v.addEventListener('click', function () {
        variants.forEach(function (x) { x.classList.remove('is-active'); });
        v.classList.add('is-active');
        if (idInput) idInput.value = v.getAttribute('data-eg-variant');
      });
    });
    if (minus && qtyInput) minus.addEventListener('click', function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); });
    if (plus && qtyInput) plus.addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; });
  }

  /* ---------- Quick add to cart (AJAX) ---------- */
  function initQuickAdd(root) {
    root.addEventListener('submit', function (e) {
      var form = e.target.closest('form');
      if (!form || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
      e.preventDefault();
      var btn = e.submitter || form.querySelector('[type="submit"]');
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.dataset.egLabel = label; btn.textContent = 'Adding…'; }
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (item) {
          toast((item && item.product_title ? item.product_title : 'Item') + ' added to cart');
          document.dispatchEvent(new CustomEvent('eg:cart:added', { detail: item }));
          if (btn) { btn.disabled = false; btn.textContent = btn.dataset.egLabel || label; }
        })
        .catch(function () {
          if (btn) { btn.disabled = false; btn.textContent = btn.dataset.egLabel || label; }
          form.submit();
        });
    });
  }
  root_click_add(); // direct "+" buttons that aren't forms
  function root_click_add() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-eg-quick-add]');
      if (!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-eg-quick-add');
      if (!id) return;
      btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: id, quantity: 1 }) })
        .then(function (r) { return r.json(); })
        .then(function (item) { toast((item && item.product_title ? item.product_title : 'Item') + ' added to cart'); document.dispatchEvent(new CustomEvent('eg:cart:added', { detail: item })); btn.disabled = false; })
        .catch(function () { btn.disabled = false; });
    });
  }

  /* ---------- Toast ---------- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'eg-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '<span class="ck">\u2713</span> ' + msg;
    toastEl.classList.add('is-show');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-show'); }, 2400);
  }

  /* ---------- Init all ---------- */
  var _quickAddBound = false;
  function initAll() {
    document.querySelectorAll('.ellara-grace [data-eg-section]').forEach(function (section) {
      initGallery(section);
      initCarousel(section);
      initBeforeAfter(section);
      initFaq(section);
      initRoutine(section);
      initBuybox(section);
    });
    document.querySelectorAll('.ellara-grace').forEach(function (r) {
      initDrawer(r);
    });
    if (!_quickAddBound) { initQuickAdd(document); _quickAddBound = true; }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Shopify theme editor lifecycle */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:select', function (e) {
    var s = e.target.querySelector('[data-eg-faq-item]');
    if (s) s.classList.add('is-open');
  });
})();
